import { useCallback } from "react";
import { useNavigate } from "react-router";
import SimpleFrame from "../../components/simple";
import { isTelegramWebApp } from "../../utils/telegram";
import styles from "./styles.module.css";

function LinkEmailSuccessPage() {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/", { replace: true });
  };

  const goToSite = useCallback(() => {
    const url = `${window.location.origin}/`;
    if (isTelegramWebApp()) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const tg = (window as any).Telegram?.WebApp;
      if (tg?.openLink) {
        tg.openLink(url);
        return;
      }
    }
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.backgroundContainer}>
        <img src="/images/succes-background.png" alt="" />
      </div>
      <SimpleFrame
        title="Email привязан"
        subtitle="Теперь можете управлять подпиской на сайте"
        buttonLabel="Вернуться на главную"
        handleClick={goHome}
        secondaryButtonLabel="Перейти на сайт"
        onSecondaryClick={goToSite}
      />
    </div>
  );
}

export default LinkEmailSuccessPage;
